<template>
  <div>
    <div class="row">
      <alerts-form @notification-sent="onNotificationSent()"></alerts-form>
    </div>
    <hr>
    <div class="row">
      <alerts-table ref="alertsTable"></alerts-table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script type="text/babel">
  import AlertsForm from './AlertsContent/AlertsForm'
  import AlertsTable from './AlertsContent/AlertsTable'
  export default {
    name: "Alerts",
    
    components: {
      AlertsForm,
      AlertsTable
    },

    props: ["customer"],

    methods: {
      onNotificationSent() {
        this.$refs.alertsTable.getNotificationsAfterSending()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/Alerts.vue